// ExpenseForm Component
/* eslint indent: 0, react/jsx-indent: 0 */

import classnames from 'classnames'
import _ from 'lodash'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import ReactSelect from 'react-select'
import Button from '../../../common/common/button/button.jsx'
import ContentMessage from '../../../common/common/content_message/content_message.jsx'
import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import PriceText from '../../../common/common/price_text/price_text.jsx'
import DialogAlert from '../../../common/dialog/dialog_alert/dialog_alert.jsx'
import FormAutoComplete from '../../../common/form/auto_complete/auto_complete.jsx'
import Checkbox from '../../../common/form/checkbox/checkbox.jsx'
import FormDatePicker from '../../../common/form/form_datepicker/form_datepicker.jsx'
import Input from '../../../common/form/input/input.jsx'
import InputPrice from '../../../common/form/input_price/input_price.jsx'
import Select from '../../../common/form/select/select.jsx'
import currency from '../../../lib/currency.jsx'
import DateUtil from '../../../lib/dateutil.jsx'
import FabButtonManager from '../../../lib/fabbuttonmanager.jsx'
import Util from '../../../lib/util.jsx'
import DialogBudgetExpenseAdd from '../../dialog/dialog_budget_expense_add/dialog_budget_expense_add.jsx'
import DocumentUpload from '../document_upload/document_upload.jsx'
import ExpenseAmountItem from '../expense_amount_item/expense_amount_item.jsx'
import ExpenseBudgetItem from '../expense_budgetitem/expense_budgetitem.jsx'

const ALLOWED_ATTACHMENTS = ['png', 'jpg', 'jpeg', 'pdf']

class ExpenseForm extends Component {
  constructor (props) {
    super(props)

    this.state = {
      active: false,
      stepIndex: 1,
      bAmountFocus: false,
      uploadErr: '',
      activeIdx: '',
      errAmountNotMatched: '',
      file: null,
      bDeleteFile: false,
      bUploadFile: false,
      showDifference: false,
      disableSubmit: false,
      isPaid: false,
      quickbookAccount: '',
      quickbookPaymentMethod: '',
      quickbookActivity: ''
    }

    this.data = {
      edit: false,
      expenseId: null,
      expense: null,
      enableSendQuickbook: false,
      items: [],
      contacts: [],
      searchTimer: 0,
      deletedItemIds: [],
      searchOptions: [],
      searchKeyword: '',
      noBudgetItem: 0,
      quickbookAccounts: [],
      quickbookPaymentMethods: [],
      quickbookActivities: []
    }

    this._references = {
      confirmAmount: React.createRef(),
      dialogBudgetExpenseAdd: React.createRef(),
      inputContact: React.createRef(),
      inputInvoiceNo: React.createRef(),
      refInvoiceDatePicker: React.createRef(),
      inputTotal: React.createRef(),
      qbAccountSelect: React.createRef(),
      qbPaymentMethodSelect: React.createRef(),
      qbActivitySelect: React.createRef()
    }

    this._validateStep = false
    this._bContactSearchPending = false
    this._contactSearchKeyword = ''
    this._bItemSelectionChanged = false
  }

  static get propTypes () {
    return {
      onSubmit: PropTypes.func,
      contactsearch: PropTypes.func,
      getProjects: PropTypes.func,
      getContactBudgetItems: PropTypes.func,
      onAddBudgetExpense: PropTypes.func,
      onClose: PropTypes.func,
      onSelectBudgetExpense: PropTypes.func,
      onSearchBudgetItem: PropTypes.func,
      onCreateContact: PropTypes.func,
      attachment: PropTypes.bool,
      validateExpenseTotalWithPO: PropTypes.func,
      uploadError: PropTypes.func,
      vatLevels: PropTypes.array,
      contactName: PropTypes.string,
      contactId: PropTypes.string,
      projectId: PropTypes.string,
      showVat: PropTypes.bool,
      onValidateInvoiceNo: PropTypes.func,
      showError: PropTypes.func,
      reloadQuickbookItems: PropTypes.func,
      getQuickbookItems: PropTypes.func,
      defaultVat: PropTypes.number,
      isQuickbookConnected: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      onSubmit: null,
      contactsearch: null,
      getProjects: null,
      getContactBudgetItems: null,
      onAddBudgetExpense: null,
      onClose: null,
      onSelectBudgetExpense: null,
      onSearchBudgetItem: null,
      onCreateContact: null,
      attachment: false,
      validateExpenseTotalWithPO: null,
      uploadError: null,
      vatLevels: [],
      contactName: '',
      contactId: null,
      projectId: null,
      showVat: false,
      onValidateInvoiceNo: null,
      showError: null,
      defaultVat: 0,
      isQuickbookConnected: false,
      reloadQuickbookItems: null,
      getQuickbookItems: null
    }
  }

  componentDidUpdate (prevProps, prevState) {
    // If step changed for validating error
    const currStep = this.state.stepIndex
    if (
      this.state.active &&
      prevState.stepIndex !== currStep &&
      this._validateStep
    ) {
      this._validateStep = false

      if (currStep === 1) {
        this._validateStep1()
      } else if (currStep === 2) {
        this._validateStep2()
      } else if (currStep === 3) {
        this._validateStep3()
      }
    }
  }

  show (expense, bEdit, items) {
    FabButtonManager.setVisible(false)
    this.data.edit = bEdit
    this.data.items = _.cloneDeep(items)
    this.data.existingItems = _.cloneDeep(items)

    this.data.quickbookAccounts = []
    this.data.quickbookPaymentMethods = []
    this.data.quickbookActivities = []

    if (this.props.getQuickbookItems) {
      const {
        accounts: quickbookAccounts,
        paymentMethods: quickbookPaymentMethods,
        activities: quickbookActivities
      } = this.props.getQuickbookItems()

      this.data.quickbookAccounts = quickbookAccounts || []
      this.data.quickbookPaymentMethods = quickbookPaymentMethods || []
      this.data.quickbookActivities = quickbookActivities || []
    }

    let fileObj = null
    let quickbookObj = {}
    if (expense !== undefined && expense) {
      this.data.expenseId = expense.id || null
      this.data.expense = _.cloneDeep(expense)
      this.data.expense.contactName = ''
      this.data.expense.subtotal = expense.total || 0
      this.data.expense.displayContactName = expense.contact
        ? expense.contact.company
        : ''
      // TODO: possible bug here, needs to be investigated
      this.data.expense.invoiceDate ? new Date(expense.invoiceDate) : '' // eslint-disable-line

      if (expense.attachment && expense.attachment.fileName) {
        const fileName = expense.attachment.fileName
        fileObj = {
          fileName: fileName,
          name: expense.attachment.name,
          url: encodeURI(
            `/expense/preview/${expense.teamId}/${fileName}/${expense.attachment.name}`
          )
        }
      }

      quickbookObj = {
        quickbookPaymentMethod: expense.quickbookPaymentMethodId || '',
        quickbookAccount: expense.quickbookAccountId || '',
        quickbookActivity: expense.quickbookAccountActivityId || '',
        isPaid: expense.quickbookIsPaid || false
      }
    }

    if (
      !expense ||
      !expense.quickbook ||
      (expense.quickbook.status !== 'Completed' &&
        expense.quickbook.status !== 'In-Progress')
    ) {
      this.data.enableSendQuickbook = true
    }

    this.setState({
      active: true,
      file: fileObj,
      bUploadFile: false,
      quickbookAccount: quickbookObj.quickbookAccount || '',
      quickbookPaymentMethod: quickbookObj.quickbookPaymentMethod || '',
      quickbookActivity: quickbookObj.quickbookActivity || '',
      isPaid: quickbookObj.isPaid || false
    })
  }

  hide (bWaitForQuickbook = false) {
    if (bWaitForQuickbook) {
      return
    }

    this._bItemSelectionChanged = false

    FabButtonManager.setVisible(true)
    this.data = {
      edit: false,
      expense: null,
      items: [],
      contacts: [],
      searchTimer: 0,
      deletedItemIds: [],
      searchOptions: [],
      searchKeyword: ''
    }

    this.setState({
      active: false,
      stepIndex: 1,
      bAmountFocus: false,
      uploadErr: '',
      activeIdx: '',
      errAmountNotMatched: '',
      file: null,
      bUploadFile: false,
      bDeleteFile: false,
      disableSubmit: false,
      quickbookAccount: '',
      quickbookPaymentMethod: '',
      quickbookActivity: '',
      isPaid: false
    })
  }

  componentDidMount () {
    document.body.addEventListener('keydown', this._onKeyDown)
  }

  componentWillUnmount () {
    document.body.removeEventListener('keydown', this._onKeyDown)
  }

  _onKeyDown = ev => {
    if (this.state.active && ev.keyCode === 13) {
      this._handleSubmit(ev)
    } else if (this.state.active && ev.keyCode === 27) {
      this.hide()
    }
  }

  render () {
    const _wizCls = classnames('wizard-form wizard-form_expense', {
      active: this.state.active
    })

    if (!this.data.expense) {
      return <div className={_wizCls} />
    }

    return (
      <div className={_wizCls}>
        <form
          className='form expenseform'
          method='post'
          onSubmit={this._handleSubmit.bind(this)}
        >
          <div className='wfrmstepinfo'>
            <IconButton
              icon='wizard-close'
              className='modal wizard-close'
              canHover={false}
              onClick={this._onClickClose.bind(this)}
            />
            {this._renderStepsInfo()}
            {this._renderStepsAction()}
          </div>
          <div className='wfrmstepcontent'>
            {this._renderStepsContent()}
            <div className='stepsaction'>
              <IconButton
                className='wizard-submit'
                icon='common-success-tick'
                title='project.form.tipSave'
                canHover={false}
                type='primary'
                size='big'
                tooltip='project.form.tipSaveClose'
                tooltipPosition='top'
                onClick={this._handleSubmit.bind(this)}
              />
            </div>
          </div>
          <DialogAlert
            ref={this._references.confirmAmount}
            title='expense.form.confirmExpenseExceeds'
            message='expense.form.confirmExpenseExceedsInfo'
            onCancel={this._onCancelValidate.bind(this)}
            onOk={this._onConfirmValidate.bind(this)}
          />
        </form>
        <DialogBudgetExpenseAdd
          ref={this._references.dialogBudgetExpenseAdd}
          contactSearch={this.props.contactsearch}
          getProjects={this.props.getProjects}
          prefixCurrency={currency.symbol()}
          onSearchBudgetItem={this._onSearchBudgetItem.bind(this)}
          onCreate={this._onCreateAddExpense.bind(this)}
          onSelect={this._onSelectExpense.bind(this)}
          contactName={this.props.contactName}
          contactId={this.props.contactId}
          projectId={this.props.projectId}
        />
      </div>
    )
  }

  enableSubmit () {
    this.setState({ disableSubmit: false })
  }

  /* Event handlers */
  _validateStep1 () {
    const expense = this.data.expense
    const newClientName = expense.contactName ? expense.contactName : null
    let noErrors = 0

    if (
      (this._references.refInvoiceDatePicker.current &&
        !this._references.refInvoiceDatePicker.current.validate()) ||
      !expense.invoiceDate
    ) {
      noErrors++
    }

    if (!newClientName) {
      if (
        (this._references.inputContact.current &&
          !this._references.inputContact.current.validate()) ||
        !expense.contactId
      ) {
        noErrors++
        this._references.inputContact.current.showError()
      }
    }

    if (
      (this._references.inputInvoiceNo.current &&
        !this._references.inputInvoiceNo.current.validate()) ||
      !expense.invoiceNo
    ) {
      noErrors++
    }

    if (
      (this._references.inputTotal.current &&
        !this._references.inputTotal.current.validate()) ||
      !expense.total
    ) {
      noErrors++
    }

    return !(noErrors > 0)
  }

  _validateStep2 () {
    return !!_.find(this.data.items, obj => obj.selected)
  }

  _validateStep3 () {
    const subtotal = _.sumBy(this.data.items, item =>
      item.selected ? parseFloat(item.invoiceTotal) : 0
    )
    const expenseTotal = parseFloat(this.data.expense.total)
    if (parseFloat(subtotal.toFixed(2)) !== expenseTotal) {
      this.data.expense.diff =
        Math.round((subtotal - expenseTotal) * 100, 2) / 100
      return false
    }

    if (this.props.isQuickbookConnected) {
      if (
        (this.state.paid &&
          this._references.qbAccountSelect.current &&
          !this._references.qbAccountSelect.current.validate()) ||
        (this._references.qbPaymentMethodSelect.current &&
          !this._references.qbPaymentMethodSelect.current.validate()) ||
        (this._references.qbActivitySelect.current &&
          !this._references.qbActivitySelect.current.validate())
      ) {
        return false
      }

      if (
        !this.state.paid &&
        this._references.qbAccountSelect.current &&
        !this._references.qbAccountSelect.current.validate()
      ) {
        return false
      }
    }

    return true
  }

  _handleSubmit (ev) {
    ev.preventDefault()

    let noErrors = 0

    if (!this._validateStep1()) {
      noErrors++
      this._validateStep = true
      this.setState({ stepIndex: 1 })
    } else if (!this._validateStep2()) {
      noErrors++
      this._validateStep = true
      this.setState({ stepIndex: 2 })
    }

    if (!this._validateStep3()) {
      noErrors++
      const stateObj = { errAmountNotMatched: true, showDifference: true }
      if (!this._validateStep) {
        this._validateStep = true
        stateObj.stepIndex = 3
      }

      this.setState(stateObj)
    } else {
      this.setState({ errAmountNotMatched: false })
    }

    if (this.props.attachment && !this.state.file) {
      noErrors++
      this.setState({ uploadErr: 'upload pdf is required' })
    }

    const items = []
    this.data.items.map((item, _itemIdx) => {
      if (item.selected) {
        const selItem = _.cloneDeep(item)
        delete selItem.selected

        if (selItem.vatAmount === undefined) {
          selItem.vatAmount = 0
        }

        items.push(selItem)
      }
    })

    if (noErrors === 0 && !this.state.disableSubmit) {
      if (this.props.validateExpenseTotalWithPO) {
        if (this.props.validateExpenseTotalWithPO(items)) {
          this._processAfterSubmit()
        } else {
          if (this._references.confirmAmount.current) {
            this._references.confirmAmount.current.show()
          }
        }
      }
    }
  }

  _processAfterSubmit () {
    const expense = this.data.expense
    const newClientName = expense.contactId ? null : expense.contactName

    let invoiceDate = expense.invoiceDate
    if (invoiceDate && typeof invoiceDate === 'object') {
      invoiceDate = DateUtil.fixDateUTCOffset(invoiceDate).toISOString()
    }

    const expenseObj = {
      contactId: newClientName ? null : expense.contactId,
      invoiceNo: expense.invoiceNo,
      invoiceDate: invoiceDate,
      total: parseFloat(expense.total),
      vatAmount: parseFloat(expense.vatAmount || 0),
      diff: expense.diff,
      description: expense.description,
      bSendQuickbook: this.data.enableSendQuickbook
    }

    const items = []
    const closePoIds = []

    this.data.items.map((item, _itemIdx) => {
      if (item.selected) {
        if (item.bClosePo && item.purchaseOrder && item.purchaseOrder.id) {
          closePoIds.push(item.purchaseOrder.id)
        }

        const selItem = _.cloneDeep(item)
        delete selItem.selected
        delete selItem.bClosePo
        delete selItem.openPoAmount
        delete selItem.totalPoAmount

        items.push(selItem)
      }
    })

    let newContactData = null
    if (newClientName) {
      newContactData = {
        company: newClientName
      }
    }

    if (this.props.isQuickbookConnected) {
      expenseObj.quickbookAccountId = this.state.quickbookAccount || ''
      expenseObj.quickbookIsPaid = false
      expenseObj.quickbookPaymentMethodId = ''
      expenseObj.quickbookAccountActivityId = ''

      if (this.state.isPaid) {
        expenseObj.quickbookPaymentMethodId =
          this.state.quickbookPaymentMethod || ''
        expenseObj.quickbookAccountActivityId =
          this.state.quickbookActivity || ''
        expenseObj.quickbookIsPaid = true
      }
    }

    const expenseId =
      this.data.expense && this.data.expense.id ? this.data.expense.id : null
    if (this.props.onSubmit) {
      this.setState({ disableSubmit: true })
      this.props.onSubmit(
        expenseObj,
        expenseId,
        items,
        this.data.deletedItemIds,
        this.state.bUploadFile ? this.state.file : null,
        this.state.bDeleteFile,
        closePoIds,
        newContactData,
        this._onSaveCompleted.bind(this)
      )
    }
  }

  _onSaveCompleted () {
    this.setState({ disableSubmit: false })
  }

  _onConfirmValidate (ev) {
    ev.preventDefault()
    this._processAfterSubmit()
  }

  _onCancelValidate () {
    this.setState({ disableSubmit: false, dataDate: new Date() })
  }

  _onCreateAddExpense (expBudgetObj) {
    if (this._references.dialogBudgetExpenseAdd.current) {
      this._references.dialogBudgetExpenseAdd.current.hide()
    }

    // If new contact, first create it before creating budget
    this._createNewContact(() => {
      if (this.props.onAddBudgetExpense) {
        this.props.onAddBudgetExpense(
          this.data.expense.contactId,
          expBudgetObj,
          newItem => {
            this._bItemSelectionChanged = true
            this.data.noBudgetItem++
            if (newItem) {
              newItem.vat = this.props.defaultVat
              newItem.vatAmount = this._getVatAmount(
                newItem.invoiceTotal,
                newItem.vat
              )
              this.data.items.push(newItem)
              this._refresh()
            }
          }
        )
      }
    })
  }

  _createNewContact (callback) {
    if (!this.data.expense.contactId) {
      const contactData = {
        company: this.data.expense.contactName
      }

      this.props.onCreateContact(contactData, contactRes => {
        this.data.expense.contactId = contactRes.id
        this.data.expense.contact = contactRes
        this.data.expense.contactName = ''
        this.data.expense.displayContactName = contactRes.company
        // Reload contacts
        this._processContactSearch(contactRes.company, false)
        callback()
      })
    } else {
      callback()
    }
  }

  _onSelectExpense (expBudgetObj) {
    if (this._references.dialogBudgetExpenseAdd.current) {
      this._references.dialogBudgetExpenseAdd.current.hide()
    }

    // If new contact, first create it before creating budget
    this._createNewContact(() => {
      if (this.props.onSelectBudgetExpense) {
        this.props.onSelectBudgetExpense(
          this.data.expense.contactId,
          expBudgetObj,
          newItem => {
            if (newItem) {
              newItem.vat = this.props.defaultVat
              newItem.vatAmount = this._getVatAmount(
                newItem.invoiceTotal,
                newItem.vat
              )
              this.data.items.push(newItem)
              this._refresh()
            }
          }
        )
      }
    })
  }

  _onClickDate (name, value, ev) {
    ev.preventDefault()

    this.setState({ [name]: value })
  }

  _refresh () {
    this.setState({ dataDate: new Date() })
  }

  _onChangeInput (name, value) {
    this.data.expense[name] = value
    this._refresh()
  }

  _onChangeTotal (value) {
    this.data.expense.total = value
    this._updateExpenseTotal()
    this._processBudgetItemTotal()

    this._refresh()
  }

  _onContactAdd (contactName) {
    this.data.expense.contactName = contactName
    this.data.expense.contactId = ''
    this._refresh()
  }

  _handleStepChange (step, e) {
    e.preventDefault()
    const expense = this.data.expense

    if (step === 3 && this._bItemSelectionChanged) {
      this._bItemSelectionChanged = false
      this._processBudgetItemTotal()
    }

    if (this.props.onValidateInvoiceNo && (step === 2 || step === 3)) {
      this.props.onValidateInvoiceNo(
        expense.id || null,
        expense.contactId,
        expense.invoiceNo,
        bError => {
          if (!bError) {
            this.setState({ stepIndex: step })
          } else {
            if (this._references.inputInvoiceNo.current) {
              this._references.inputInvoiceNo.current.showError()
            }

            this.props.showError('expense.list.errorInvoiceNoAlreadyExists')
          }
        }
      )
    } else {
      this.setState({ stepIndex: step })
    }
  }

  _onClickClose (ev) {
    ev.preventDefault()
    if (this.props.onClose) {
      this.props.onClose(this.data.noBudgetItem)
    }
  }

  _getValidateClass (step) {
    return classnames('stepinfo', {
      active: this.state.stepIndex === step,
      complete: this._getIsCompleted(step),
      error: this._getHasError(step)
    })
  }

  _processBudgetItemTotal () {
    // If we have only one time selected, then we can use the invoice total as item total
    // On going to 3rd step we have to do auto adjust

    const expense = this.data.expense
    const expenseTotal = parseFloat(expense.total)
    // Reset subtotal and difference
    expense.subtotal = 0
    expense.diff = expenseTotal

    if (expenseTotal > 0) {
      const selectedItems = _.filter(this.data.items, item => item.selected)
      if (selectedItems.length === 1) {
        const selectedItem = selectedItems[0]
        selectedItem.bAdjusted = true
        selectedItem.invoiceTotal = expenseTotal
        selectedItem.vatAmount = this._getVatAmount(
          selectedItem.invoiceTotal,
          selectedItem.vat
        )

        // If we have only one time selected, then we can use the expense subtotal as expense total and diff is 0
        expense.subtotal = expenseTotal
        expense.diff = 0
        expense.vatAmount = selectedItem.vatAmount
          ? parseFloat(selectedItem.vatAmount)
          : 0
      } else {
        selectedItems.map(item => {
          if (item.bAdjusted) {
            item.bAdjusted = false
            item.invoiceTotal = 0
            item.vatAmount = 0
          }
        })
      }
    }
  }

  _getIsCompleted (step) {
    const expense = this.data.expense
    let bComplete = false

    if (step === 1) {
      bComplete =
        expense.invoiceNo &&
        parseFloat(expense.total) &&
        expense.invoiceDate &&
        (expense.contactId || expense.contactName)
    } else if (step === 2) {
      bComplete = expense.invoiceDate && expense.endDate
    } else if (step === 3) {
      bComplete =
        !this.state.errAmountNotMatched &&
        this.data.items &&
        this.data.items.length > 0
    }

    return bComplete
  }

  _getHasError (step) {
    const expense = this.data.expense
    let bError = false

    if (step === 1) {
      bError = !expense.title || (!expense.contactId && !expense.contactName)
    } else if (step === 3) {
      bError = expense.diff !== 0
    }

    return bError
  }

  _handleSearchContact (keyword) {
    this.data.expense.displayContactName = keyword
    this._refresh()

    this._processContactSearch(keyword, true)
  }

  _processContactSearch (keyword, bClearContact) {
    if (keyword.length < 1) return

    if (!this._bContactSearchPending) {
      this._bContactSearchPending = true
      if (this.props.contactsearch) {
        this.props.contactsearch(
          keyword,
          this._onSearchReceived.bind(this, keyword, bClearContact)
        )
      }
    } else {
      this._contactSearchKeyword = keyword
    }
  }

  _onSearchReceived (keyword, bClearContact, result) {
    this._bContactSearchPending = false

    this.data.contacts = result
    const expense = this.data.expense

    if (bClearContact && result && result.length > 0) {
      expense.contactId = ''
      expense.contactName = ''
    }
    this._refresh()

    if (this._contactSearchKeyword) {
      const keyword = this._contactSearchKeyword
      this._contactSearchKeyword = ''
      this._processContactSearch(keyword, true)
    }
  }

  _handleContactSelect (contactObj) {
    if (!contactObj) {
      this.data.items = []
      const expense = this.data.expense
      expense.contactId = null

      this._refresh()

      return
    }

    let existingItems = this.data.existingItems || []

    if (this.data.expense.displayContactName !== contactObj.label) {
      existingItems = []
    }

    // If supplier got changed, delete the existing expense items
    if (
      this.data.expense.contact &&
      this.data.expense.contact.id !== contactObj.value
    ) {
      // Remove all existing items
      this.data.items = []

      existingItems.map(item => {
        if (item.id) {
          this.data.deletedItemIds.push(item.id)
        }
      })
    } else {
      // If same supplier selected, reset the items as like when it is opened
      _.remove(
        this.data.deletedItemIds,
        delId => _.findIndex(existingItems, item => item.id === delId) >= 0
      )

      // Reset with old items
      this.data.items = existingItems
    }

    const expense = this.data.expense
    expense.displayContactName = contactObj.label
    expense.contactId = contactObj.value

    if (this.props.getContactBudgetItems) {
      this.props.getContactBudgetItems(
        contactObj.value,
        null,
        null,
        null,
        items => {
          const expenseTotal = parseFloat(expense.total)
          if (items.length === 1) {
            items[0].selected = true
            items[0].invoiceTotal = expenseTotal
            expense.subtotal = expenseTotal
            expense.diff = 0
          }

          items.map((item, _itemIdx) => {
            // If item already exists use that, else use new item
            const existingItem = _.find(
              existingItems,
              exItem =>
                exItem.budgetItemId === item.budgetItemId &&
                exItem.budgetItemSupplierId === item.budgetItemSupplierId
            )
            if (!existingItem) {
              item.vatAmount = this._getVatAmount(
                item.invoiceTotal,
                item.vat || 0
              )
              this.data.items.push(item)
            }
          })

          this._refresh()
        }
      )
    } else {
      this._refresh()
    }
  }

  _onFocus (_name, _value) {
    if (this._references.refInvoiceDatePicker.current) {
      this._references.refInvoiceDatePicker.current.showDatePicker()
    }
  }

  _onChangeDate (name, value) {
    this.data.expense[name] = value ? new Date(value) : ''
    this.setState({ dataDate: new Date() })
  }

  _onAddBudgetExpense (e) {
    e.preventDefault()
    // If supplier is not set, move to first tab
    if (!this.data.expense.contactId && !this.data.expense.contactName) {
      this._validateStep = true
      this.setState({ stepIndex: 1 })
    } else {
      if (this._references.dialogBudgetExpenseAdd.current) {
        this._references.dialogBudgetExpenseAdd.current.show()
      }
    }
  }

  _handleUploadSuccess (file, message, e) {
    const ext = Util.getExtension(message.id)

    if (ALLOWED_ATTACHMENTS.includes(ext)) {
      this.setState({
        file: {
          fileName: message.id,
          name: file.name,
          url: `/asset/${message.id}`
        },
        uploadErr: '',
        dataDate: new Date(),
        bUploadFile: true
      })
    } else {
      e.preventDefault()
      e.stopPropagation()
      this.setState({ uploadErr: 'hasErr', dataDate: new Date() })
    }
  }

  _handleUploadError (_file, message) {
    if (message) {
      this.setState({ uploadErr: 'hasErr', dataDate: new Date() })
      if (this.props.uploadError) {
        this.props.uploadError(message)
      }
    }
  }

  _onDeleteAttachment () {
    this.setState({
      file: null,
      bDeleteFile: true,
      uploadErr: '',
      bUploadFile: false,
      dataDate: new Date()
    })
  }

  _onSearchBudgetItem (projectId, phaseNo, keyword, callback) {
    if (this.props.onSearchBudgetItem) {
      const excludeIds = []
      this.data.items.map(item => {
        if (item.selected) {
          excludeIds.push(item.budgetItemId)
        }
      })

      this.props.onSearchBudgetItem(
        projectId,
        phaseNo,
        keyword,
        excludeIds,
        callback
      )
    }
  }

  /* Private functions */
  _renderStepsContent () {
    return (
      <div className='stepscontent'>
        {this._renderStep1()}
        {this._renderStep2()}
        {this._renderStep3()}
      </div>
    )
  }

  _onContactAddToggle (bAddShown) {
    // Remove items
    this.data.items.map(item => {
      if (item.id) {
        this.data.deletedItemIds.push(item.id)
      }
    })

    this.data.items = []

    if (bAddShown) {
      this.data.expense.contactId = null
      this.data.expense.contactName = this.data.expense.displayContactName
      this._refresh()
    } else {
      this.data.expense.contactId = null
      this.data.expense.contactName = ''
      this._refresh()
    }
  }

  _renderStepsInfo () {
    const expense = this.data.expense
    const items = this.data.items
    const statusTick = <i className='icon icon-list-tick' />

    return (
      <div className='stepsinfo'>
        <div
          className={this._getValidateClass(1)}
          onClick={this._handleStepChange.bind(this, 1)}
        >
          <div className='stepstatus'>
            {this._getIsCompleted(1) ? statusTick : ''}
          </div>
          <div className='stepitem'>
            <h4>
              <IntlMessage ident='expense.form.expenseInfo' />
            </h4>
            {expense.displayContactName ? (
              <div className='info'>
                {expense.displayContactName},
                <IntlMessage ident='expense.form.invoiceTotal' />
                <PriceText value={expense.total} />
              </div>
            ) : (
              <div className='info'>
                <IntlMessage ident='expense.form.missingSupplier' />
              </div>
            )}
          </div>
        </div>
        <div
          className={this._getValidateClass(2)}
          onClick={this._handleStepChange.bind(this, 2)}
        >
          <div className='stepstatus'>
            {this._getIsCompleted(2) ? statusTick : ''}
          </div>
          <div className='stepitem'>
            <h4>
              <IntlMessage ident='expense.form.budgetPoInfo' />
            </h4>
            {items && items.length > 0 ? (
              <div className='info'>
                {items.length}
                &nbsp;
                <IntlMessage ident='expense.form.addedExpenseInfo' />
              </div>
            ) : (
              <div className='info'>
                <IntlMessage ident='expense.form.noExpenseInfo' />
              </div>
            )}
          </div>
        </div>
        <div
          className={this._getValidateClass(3)}
          onClick={this._handleStepChange.bind(this, 3)}
        >
          <div className='stepstatus'>
            {this._getIsCompleted(3) ? statusTick : ''}
          </div>
          <div className='stepitem'>
            <h4>
              <IntlMessage ident='expense.form.adjustAmount' />
            </h4>
            {expense.total && expense.total > 0 ? (
              <div className='info'>
                <PriceText value={expense.total} />
              </div>
            ) : (
              <div className='info'>
                <IntlMessage ident='expense.form.totalCheckInfo' />
              </div>
            )}
          </div>
        </div>
        <div className='upload-wrap'>
          <DocumentUpload
            fileObj={this.state.file}
            uploadSuccess={this._handleUploadSuccess.bind(this)}
            uploadError={this._handleUploadError.bind(this)}
            error={this.state.uploadErr}
            onDeleteClick={this._onDeleteAttachment.bind(this)}
            allowedAttachments={ALLOWED_ATTACHMENTS}
          />
        </div>
      </div>
    )
  }

  _renderStepsAction () {
    if (!this.state.active) {
      return ''
    }

    let prevStepClass = 'wizard wizardprev disabled'
    let nextStepClass = 'wizard wizardnext disabled'

    if (this.state.stepIndex > 1) {
      prevStepClass = 'wizard wizardprev'
    }

    if (this.state.stepIndex < 3) {
      nextStepClass = 'wizard wizardnext'
    }

    return (
      <div className='stepsaction'>
        <IconButton
          className={prevStepClass}
          icon='common-previousstep'
          title='project.form.tipPreviousStep'
          canHover={false}
          size='big'
          tooltip='project.form.tipPreviousStep'
          tooltipPosition='top'
          onClick={this._handleStepChange.bind(this, this.state.stepIndex - 1)}
        />
        <IconButton
          className={nextStepClass}
          icon='common-nextstep'
          title='project.form.tipNextStep'
          canHover={false}
          size='big'
          tooltip='project.form.tipNextStep'
          tooltipPosition='top'
          onClick={this._handleStepChange.bind(this, this.state.stepIndex + 1)}
        />

        <IconButton
          className={`wizard-submit${
            this.state.disableSubmit ? ' disablesubmit' : ''
          }`}
          icon='common-success-tick'
          title='project.form.tipSave'
          canHover={false}
          type='primary'
          size='big'
          disabled={this.state.disableSubmit}
          onClick={this._handleSubmit.bind(this)}
        />
      </div>
    )
  }

  _renderStep1 () {
    if (this.state.stepIndex !== 1) {
      return ''
    }

    const expense = this.data.expense
    let contactValue = ''
    if (expense.contact) {
      contactValue = expense.contact.company
    }

    return (
      <div className='wizardstep'>
        <div className='form-layout'>
          <div className='layoutcol'>
            <div className='formsection'>
              <div className='formheader'>
                <h2>
                  <IntlMessage ident='expense.form.basicExpenseTitle' />
                </h2>
              </div>
              <div className='formrow'>
                <div className='formcol'>
                  <FormAutoComplete
                    label='expense.form.labelSupplier'
                    name='contactId'
                    ref={this._references.inputContact}
                    validations={['required']}
                    options={this.data.contacts}
                    value={contactValue}
                    displayValue={expense.displayContactName}
                    onChange={this._handleSearchContact.bind(this)}
                    onSelect={this._handleContactSelect.bind(this)}
                    addLabel='project.form.addNewSupllier'
                    addValue={expense.contactName}
                    addName='contactName'
                    showAdd={!!expense.contactName}
                    onAddChange={this._onContactAdd.bind(this)}
                    hasAutoSelect
                    onToggleAdd={this._onContactAddToggle.bind(this)}
                  />
                </div>
              </div>
              <div className='formrow'>
                <div className='formcol2'>
                  <Input
                    type='text'
                    name='invoiceNo'
                    label='expense.form.labelInvoice'
                    value={expense.invoiceNo}
                    size={10}
                    maxLength={100}
                    ref={this._references.inputInvoiceNo}
                    validations={['required']}
                    onChange={this._onChangeInput.bind(this, 'invoiceNo')}
                    onKeyDown={this._onKeyPressInvoiceInput.bind(
                      this,
                      'invoiceNo'
                    )}
                  />
                </div>
                <div className='formcol2'>
                  <FormDatePicker
                    label='expense.form.labelInvoiceDate'
                    placeholder='expense.form.labelInvoiceDate'
                    ref={this._references.refInvoiceDatePicker}
                    value={
                      expense.invoiceDate ? new Date(expense.invoiceDate) : null
                    }
                    name='invoiceDate'
                    onChange={this._onChangeDate.bind(this, 'invoiceDate')}
                    onFocus={this._onFocus.bind(this, 'invoiceDate')}
                  />
                </div>
              </div>
              <div className='formrow'>
                <div className='formcol'>
                  <InputPrice
                    type='text'
                    name='total'
                    showDecimal
                    label='expense.form.labelInvoiceTotal'
                    value={expense.total}
                    prefixCurrency={currency.symbol()}
                    size={10}
                    maxLength={100}
                    ref={this._references.inputTotal}
                    validations={['required', 'price']}
                    onChange={this._onChangeTotal.bind(this)}
                  />
                </div>
              </div>
              <div className='formrow'>
                <div className='formcol'>
                  <Input
                    type='text'
                    name='description'
                    label='expense.form.labelDescription'
                    value={expense.description}
                    size={10}
                    maxLength={100}
                    styleDotted
                    onChange={this._onChangeInput.bind(this, 'description')}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  _renderStep2 () {
    if (this.state.stepIndex !== 2) {
      return ''
    }

    return (
      <div className='wizardstep wizardstep_step2'>
        <div className='form-layout'>
          <div className='layoutcol'>
            <div className='formsection'>
              <div className='formrow'>{this._renderBudgetContent()}</div>
              <div className='formrow'>
                <Button
                  className='button_save'
                  title='expense.form.titleNewBudget'
                  type='button'
                  icon='common-add'
                  canHover={false}
                  onClick={this._onAddBudgetExpense.bind(this)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  _renderBudgetContent () {
    const items = this.data.items
    return (
      <div className='wizardstep'>
        <div className='form-layout'>
          <div className='layoutcol'>
            <div className='formsection'>
              {(this.data.edit || (items && items.length > 0)) &&
                this._renderBudgetContentHeader()}

              {items && items.length > 0 ? (
                <div className='formrow'>
                  <div className='budgetform'>
                    <div className='budgethead'>
                      <div className='budgetcol title'>
                        <IntlMessage ident='expense.form.headerActivity' />
                      </div>
                      <div className='budgetcol unit'>
                        <IntlMessage ident='expense.form.headerUnitTitle' />
                      </div>
                      <div className='budgetcol rate'>
                        <IntlMessage ident='expense.form.headerRateTitle' />
                      </div>
                      <div className='budgetcol budget'>
                        <IntlMessage ident='expense.form.headerBudget' />
                      </div>
                      <div className='budgetcol spent'>
                        <IntlMessage ident='expense.form.headerSpend' />
                      </div>
                    </div>
                    <div className='budgetcont'>
                      {this._renderExpenseItems()}
                    </div>
                  </div>
                </div>
              ) : (
                <ContentMessage
                  message='expense.form.expenseContentMsg'
                  info='expense.form.expenseContentInfo'
                  showAddPrefix={false}
                  showAdd={false}
                  showAddSuffix={false}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }

  _renderBudgetContentHeader () {
    return (
      <div className='formheader'>
        <h2>
          <IntlMessage ident='expense.form.budgetContentTitle' />
        </h2>
      </div>
    )
  }

  _renderBudgetContentSearch () {
    if (!this.data.edit) {
      return ''
    }

    const { searchOptions, searchKeyword } = this.data
    return (
      <div className='formrow'>
        <div className='formcol'>
          <FormAutoComplete
            label='expense.form.labelSearchClient'
            styleDotted
            value={searchKeyword}
            displayValue={searchKeyword}
            options={searchOptions}
            onChange={this._handleSearchExpense.bind(this)}
            onSelect={this._handleSelectExpense.bind(this)}
            hideAdd
            hasAutoSelect
          />
        </div>
      </div>
    )
  }

  _renderExpenseItems () {
    return this.data.items.map((item, idx) => {
      return (
        <ExpenseBudgetItem
          key={idx}
          expenseItem={item}
          onDelete={this._onExpenseItemDelete.bind(this)}
          onToggleSelect={this._onToggleSelectItem.bind(this)}
          selectable={!item.id}
        />
      )
    })
  }

  _renderStep3 () {
    if (this.state.stepIndex !== 3) {
      return ''
    }

    const expense = this.data.expense
    const quickbookAccounts = this.data.quickbookAccounts
    const quickbookPaymentMethods = this.data.quickbookPaymentMethods
    const quickbookActivities = this.data.quickbookActivities
    const bAmountNotMatched = !!this.state.errAmountNotMatched

    const _wizStp3RowCls = classnames('formrow alt', {
      formrow_error: bAmountNotMatched
    })

    const subtitleCls = this.props.showVat
      ? 'formrow formrow__subtitle'
      : 'formrow formrow__subtitle hidevat'

    const _qbOptClass = this.data.enableSendQuickbook
      ? 'qbintegration-opts'
      : 'qbintegration-opts edit'

    return (
      <div className='wizardstep wizardstep_step3'>
        <div className='form-layout'>
          <div className='layoutcol'>
            <div className='formsection'>
              <div className='formheader'>
                {this.state.errAmountNotMatched ? (
                  <h2 className='amountheader error'>
                    <IntlMessage ident='expense.form.errAmountNotMatched' />
                  </h2>
                ) : (
                  <h2 className='amountheader'>
                    <IntlMessage ident='expense.form.amountHeaderTitle' />
                  </h2>
                )}
              </div>
              <div className={subtitleCls}>
                <div className='formcol'>
                  <IntlMessage ident='expense.form.subTitleActivities' />
                </div>
                {this.props.showVat && (
                  <div className='formcol'>
                    <IntlMessage ident='expense.form.subTitleVat' />
                  </div>
                )}
                {this.props.showVat && (
                  <div className='formcol'>
                    <IntlMessage ident='expense.form.subTitleVatValue' />
                  </div>
                )}
                <div className='formcol'>
                  <IntlMessage ident='expense.form.subTitleVatExcl' />
                </div>
              </div>
              <div className='formrow'>
                <div className='formcol'>{this._renderSelectedItems()}</div>
              </div>
              <div className={_wizStp3RowCls}>
                <div className='formcol'>
                  <div className='expensevalue expensevalue__label'>
                    <IntlMessage ident='expense.form.labelInvoiceBudgetTotal' />
                  </div>
                  {!this.props.showVat && (
                    <div className='expensevalue'>&nbsp;</div>
                  )}
                  {this.props.showVat && (
                    <div className='expensevalue'>
                      <span className='value'>
                        <PriceText value={expense.vatAmount} />
                      </span>
                    </div>
                  )}
                  <div className='expensevalue'>
                    <span className='value'>
                      <PriceText value={expense.subtotal} />
                    </span>
                  </div>
                </div>
              </div>
              {this.state.showDifference && (
                <div className='formrow'>
                  <div className='formcol formcol_splitter' />
                </div>
              )}
              {this.state.showDifference && (
                <div className={_wizStp3RowCls}>
                  <div className='formcol'>
                    <div className='expensevalue expensevalue__label'>
                      <IntlMessage ident='expense.form.labelDifference' />
                    </div>
                    <div className='expensevalue'>&nbsp;</div>
                    <div className='expensevalue diff'>
                      <span className='value'>
                        <PriceText value={expense.diff} />
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </div>
            {this.props.isQuickbookConnected && (
              <div className={_qbOptClass}>
                <div className='title'>
                  <IntlMessage ident='expense.form.qbIntegrationHdrTitle' />
                </div>
                <div className='qboptsection'>
                  <div className='formrow'>
                    <div className='formcol'>
                      <Select
                        ref={this._references.qbAccountSelect}
                        options={quickbookAccounts}
                        name='quickbookAccount'
                        className='form-dropdown expensedropdown'
                        multilingualOptions={false}
                        label='expense.form.quickbookAccount'
                        value={this.state.quickbookAccount}
                        disabled={!this.data.enableSendQuickbook}
                        styleDotted
                        onChange={this._onChangeQuickbookItem.bind(
                          this,
                          'quickbookAccount'
                        )}
                      />
                    </div>
                    <div className='formcol checkfields'>
                      <Checkbox
                        label='expense.form.unpaid'
                        checked={!this.state.isPaid}
                        icon='common'
                        onChange={this._onChangeQbType.bind(this, false)}
                      />
                      <Checkbox
                        label='expense.form.paid'
                        checked={this.state.isPaid}
                        icon='common'
                        onChange={this._onChangeQbType.bind(this, true)}
                      />
                    </div>
                  </div>
                  {this.state.isPaid && (
                    <div className='formrow'>
                      <div className='formcol'>
                        <Select
                          ref={this._references.qbPaymentMethodSelect}
                          options={quickbookPaymentMethods}
                          name='quickbookPaymentMethod'
                          className='form-dropdown expensedropdown'
                          multilingualOptions={false}
                          label='expense.form.quickbookPaymentMethod'
                          value={this.state.quickbookPaymentMethod}
                          styleDotted
                          disabled={!this.data.enableSendQuickbook}
                          onChange={this._onChangeQuickbookItem.bind(
                            this,
                            'quickbookPaymentMethod'
                          )}
                        />
                      </div>
                    </div>
                  )}
                  {this.state.isPaid && (
                    <div className='formrow'>
                      <div className='formcol'>
                        <Select
                          ref={this._references.qbActivitySelect}
                          options={quickbookActivities}
                          name='quickbookActivity'
                          className='form-dropdown expensedropdown'
                          multilingualOptions={false}
                          label='expense.form.quickbookActivity'
                          value={this.state.quickbookActivity}
                          styleDotted
                          disabled={!this.data.enableSendQuickbook}
                          onChange={this._onChangeQuickbookItem.bind(
                            this,
                            'quickbookActivity'
                          )}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }

  _onChangeQuickbookItem (name, value) {
    if (value === '__reload__') {
      if (this.props.reloadQuickbookItems) {
        this.props.reloadQuickbookItems(name, quickbookOptions => {
          this.data.quickbookAccounts = quickbookOptions.accounts || []
          this.data.quickbookPaymentMethods =
            quickbookOptions.paymentMethods || []
          this.data.quickbookActivities = quickbookOptions.activities || []

          this.setState({ dataDate: new Date() })
        })
      }
    } else {
      this.setState({ [name]: value, dataDate: new Date() })
    }
  }

  _onChangeQbType (bPaid) {
    this.setState({ isPaid: bPaid, dataDate: new Date() })
  }

  _onClosePoItem (purchaseOrder, bChecked) {
    if (purchaseOrder && purchaseOrder.id) {
      this.data.items.forEach(item => {
        if (item.purchaseOrder && purchaseOrder.id === item.purchaseOrder.id) {
          item.bClosePo = bChecked
        }
      })
    }

    this.setState({ dataDate: new Date() })
  }

  isActive () {
    return this.state.active
  }

  _renderSelectedItems () {
    const items = this.data.items

    if (items && items.length > 0) {
      return items.map((item, idx) => {
        if (!item.selected) {
          return ''
        }
        const amountClass = this.state.activeIdx === idx ? 'active' : ''

        return (
          <ExpenseAmountItem
            key={idx}
            expenseItem={item}
            onClosePo={this._onClosePoItem.bind(this)}
            className={amountClass}
            hideVat={!this.props.showVat}
          >
            {this.props.showVat && (
              <ReactSelect
                name='vat'
                className='select-alt select-vat vat'
                value={
                  _.find(this.props.vatLevels, obj => obj.value === item.vat) ||
                  null
                }
                options={this.props.vatLevels}
                classNamePrefix='typeitem'
                clearable={false}
                openOnFocus
                onChange={this._onChangeItemVat.bind(this, item, 'vat')}
              />
            )}
            {this.props.showVat && (
              <InputPrice
                type='text'
                name='vatAmount'
                showDecimal
                label='expense.form.labelAmount'
                showPlaceholder={false}
                value={item.vatAmount}
                size={10}
                maxLength={100}
                validations={['price']}
                prefixCurrency={currency.symbol()}
                onFocus={this._onAmountAction.bind(this, idx)}
                onBlur={this._onAmountAction.bind(this, idx)}
                onChange={this._onChangeItemInput.bind(this, item, 'vatAmount')}
              />
            )}
            <InputPrice
              type='text'
              name='itemTotal'
              showDecimal
              label='expense.form.labelAmount'
              showPlaceholder={false}
              value={item.invoiceTotal}
              size={10}
              maxLength={100}
              validations={['price']}
              prefixCurrency={currency.symbol()}
              onFocus={this._onAmountAction.bind(this, idx)}
              onBlur={this._onAmountAction.bind(this, idx)}
              onChange={this._onChangeItemInput.bind(
                this,
                item,
                'invoiceTotal'
              )}
            />
          </ExpenseAmountItem>
        )
      })
    }
  }

  _onChangeItemVat (item, name, object) {
    const value = object.value
    item[name] = value
    item.vatAmount = this._getVatAmount(item.invoiceTotal, item.vat)
    this._updateExpenseTotal()
    this.setState({ showDifference: true, dataDate: new Date() })
  }

  _onChangeItemInput (item, name, value) {
    item[name] = value

    if (name === 'invoiceTotal') {
      item.vatAmount = this._getVatAmount(item.invoiceTotal, item.vat)
    } else if (name === 'vatAmount') {
      item.invoiceTotal = this._getInvoiceTotal(item.vatAmount, item.vat)
    }

    this._updateExpenseTotal()

    const isAmountMatched =
      parseFloat(this.data.expense.subtotal) ===
      parseFloat(this.data.expense.total)
    this.setState({
      showDifference: true,
      errAmountNotMatched: !isAmountMatched,
      dataDate: new Date()
    })
  }

  _onAmountAction (idx) {
    this.setState({ activeIdx: idx, dataDate: new Date() })
  }

  _updateExpenseTotal () {
    const expense = this.data.expense
    expense.subtotal = _.sumBy(this.data.items, item =>
      item.selected ? parseFloat(item.invoiceTotal) : 0
    )
    expense.vatAmount = _.sumBy(this.data.items, item =>
      item.selected ? parseFloat(item.vatAmount) : 0
    )
    expense.invoiceTotal = _.sumBy(this.data.items, item =>
      item.selected ? parseFloat(item.invoiceTotal) : 0
    )
    if (expense.total) {
      expense.diff =
        Math.round((expense.subtotal - parseFloat(expense.total)) * 100, 2) /
        100
    } else {
      expense.diff = 0
    }
  }

  _getVatAmount (amount, vat) {
    if (vat && parseFloat(vat) > 0) {
      const vatAmount = (parseFloat(amount) * parseFloat(vat)) / 100
      return vatAmount
    }

    return 0
  }

  _getInvoiceTotal (vatAmount, vat) {
    if (vat && parseFloat(vat) > 0) {
      const invoiceTotal = (parseFloat(vatAmount) * 100) / parseFloat(vat)
      return invoiceTotal
    }

    return 0
  }

  _onExpenseItemDelete (delItem) {
    _.remove(this.data.items, item => {
      if (delItem.id) {
        return delItem.id === item.id
      } else {
        return item.budgetItemId === delItem.budgetItemId
      }
    })

    if (delItem.id) {
      this.data.deletedItemIds.push(delItem.id)
    }

    this._refresh()
  }

  _onToggleSelectItem (item, bSelected) {
    this._bItemSelectionChanged = true

    if (bSelected && item.id && this.data.edit) {
      _.remove(
        this.data.deletedItemIds,
        deletedItemId => deletedItemId === item.id
      )
    }

    if (!bSelected && item.id) {
      this.data.deletedItemIds.push(item.id)
    }

    this._refresh()
  }

  _handleSearchExpense (keyword) {
    this.data.searchKeyword = keyword
    const excludeIds = []
    this.data.items.map(item => {
      if (item.selected) {
        excludeIds.push(item.budgetItemId)
      }
    })

    this.props.getContactBudgetItems(
      this.data.expense.contactId,
      keyword,
      excludeIds,
      null,
      items => {
        items.map((item, _itemIdx) => {
          item.label = item.budgetitem ? item.budgetitem.title : ''
          item.value = item.budgetItemId
        })
        this.data.searchOptions = items
        this._refresh()
      }
    )
  }

  _handleSelectExpense (selItem) {
    if (selItem) {
      selItem.selected = true
      delete selItem.label
      delete selItem.value

      this.data.searchKeyword = ''
      this.data.searchOptions = []
      this.data.items.push(selItem)

      this._refresh()
    }
  }

  _onKeyPressInvoiceInput (name, ev) {
    if (ev.keyCode === 13 || ev.keyCode === 9) {
      if (this._references.refInvoiceDatePicker.current) {
        this._references.refInvoiceDatePicker.current.showDatePicker()
      }
    }
  }
}

export default ExpenseForm
